<template>
    <form-wrapper @form-submit="submit">
        <form-row>
            <form-cell>
                <text-input
                    :formData="data"
                    :label="$t('forms.company.invite_company_user.fields.email.label')"
                    :placeholder="$t('forms.company.invite_company_user.fields.email.placeholder')"
                    :isRequired="true"
                    type="email"
                    valuePath="email"
                    @change="change"
                ></text-input>
            </form-cell>
        </form-row>

        <template #footer>
            <common-buttons>
                <common-button
                    type="primary"
                    :isProcessing="isLoading"
                    :label="$t('forms.company.invite_company_user.buttons.invite')"
                ></common-button>
            </common-buttons>
        </template>
    </form-wrapper>
</template>

<script>
    import FormMixin from 'mixins/FormMixin'
    import UsersAPI from 'api/UsersAPI'

    export default {
        mixins: [FormMixin],
        props: { companyId: { type: Number, required: true } },
        methods: {
            submit() {
                this.submitForm(
                    UsersAPI.inviteUserToTheCompany({ email: this.data.email, companyId: this.companyId }).then((response) => {
                        if (!response.user) {
                            this.$toast.success(this.$t(`forms.company.invite_company_user.messages.user_invited`))
                        }
                        this.emitEvent({ name: 'company-user-invited' })
                    }),
                ).catch((error) => {
                    this.$toast.error(
                        this.$t(
                            `forms.company.invite_company_user.errors.${error.error.message.replace('.', '_').toLowerCase()}`,
                        ),
                    )
                })
            },
        },
    }
</script>
